<template>
  <div class="flex-grow  p-6">

    <!--分类导航面包屑-开始-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">学员管理</el-breadcrumb-item>
      <el-breadcrumb-item>全部学员</el-breadcrumb-item>
    </el-breadcrumb>
    <!--分类导航面包屑-结尾-->

    <!--课件的上传批量操作-开始-->
    <div class="flex justify-between pt-6">
      <div v-if="false">
        <el-button type="primary">添加学员</el-button>
        <el-button>批量导入学员</el-button>
      </div>
      <div>
        <el-form :inline="true" :model="pageInfo" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input v-model="pageInfo.realname" placeholder="请输入要搜索的姓名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!--课件的上传批量操作-结尾-->
    <!--课件的数据列表-开始-->
    <div>
      <el-table
          :data="tableData"
          stripe
          height="calc(100vh - 390px)"
          style="width: 100%">
        <el-table-column
            prop="id"
            label="编号"
        >
        </el-table-column>
        <el-table-column
            prop="realname"
            label="学员"
        >
        </el-table-column>
        <el-table-column
            prop="number"
            label="分数"
            width="180">
        </el-table-column>
        <el-table-column
            prop="mobile"
            label="登录手机"
            width="180">
        </el-table-column>
        <el-table-column
            prop="createdTime"
            label="加入时间"
            width="180">
        </el-table-column>
      </el-table>
      <div class="py-6">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleLoadMember"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="pageInfo.page"
            :page-sizes="[20, 50, 100, 200]"
            :page-size="pageInfo.size"
            :total="pageInfo.total">
        </el-pagination>
      </div>
    </div>
    <!--课件的数据列表-结束-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageInfo: {
        realname: '',
        size: 20,
        page: 1,
        total: 0,
      },
      tableData: []
    };
  },
  mounted() {
    this.handleLoadMember()
  },
  methods: {
    handleSizeChange(val) {
      this.pageInfo.size = val
      this.handleLoadMember();
    },
    handleSearch(){
      this.handleLoadMember()
    },
    handleReset(){
      this.pageInfo.realname = ''
      this.handleSearch()
    },
    handleLoadMember() {
      this.$cloud.get("/member/index", {...this.pageInfo,}).then(data => {
        console.log("成员", data)
        this.tableData = data.children;
        this.pageInfo['total'] = data.total
      })
    }
  }
};
</script>
<style scoped>

</style>
